/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var RotateSquareRightIcon20Light = forwardRef('RotateSquareRightIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M7.812.11a.5.5 0 0 0-.624.78L8.575 2H5a4 4 0 0 0-4 4v2.5a.5.5 0 1 0 1 0V6a3 3 0 0 1 3-3h3.575L7.188 4.11a.5.5 0 0 0 .624.78l1.67-1.336a1.35 1.35 0 0 0 0-2.108L7.813.11Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 10a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3v-6Zm3-2a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2H8Z" })));
});
